import React from "react"
import FormInput from "../../../components/Form/Inputs/FormInput"
import AsyncCreatableTag from "../../../components/Form/Select/AsyncCreatableTag"
import ArtPieceSharedDetails from "./SharedDetails"
import { ART_PIECE__VIDEO_TAG_TYPE } from "../../../api/Definitions"

const ArtPieceVideo = () => {
  return (
    <>
      <ArtPieceSharedDetails />
      <FormInput name="video.resolution" label="Resolution" />
      <FormInput name="video.duration" label="Duration" />
      <AsyncCreatableTag
        name="video.type"
        group={ART_PIECE__VIDEO_TAG_TYPE}
        label="Type"
      />
    </>
  )
}

export default ArtPieceVideo
